import React from "react";
import { AlertTriangle, CheckCircle, Clock } from "lucide-react";

interface AlertSummaryProps {
  alertCount: number;
  activeAlerts: number;
  resolvedAlerts: number;
}

const AlertSummary: React.FC<AlertSummaryProps> = ({
  alertCount,
  activeAlerts,
  resolvedAlerts,
}) => {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-bold text-gray-800">
            Device Health Alerts
          </h2>
          <p className="text-gray-600 text-sm">
            Monitor and manage device alerts
          </p>
        </div>
      </div>

      {/* Alert Count Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-6 w-6 text-blue-600" />
            </div>
            <div className="ml-3">
              <p className="text-xs font-medium text-blue-600">Total Alerts</p>
              <p className="text-xl font-bold text-blue-900">{alertCount}</p>
            </div>
          </div>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Clock className="h-6 w-6 text-red-600" />
            </div>
            <div className="ml-3">
              <p className="text-xs font-medium text-red-600">Active Alerts</p>
              <p className="text-xl font-bold text-red-900">{activeAlerts}</p>
            </div>
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-3">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <CheckCircle className="h-6 w-6 text-green-600" />
            </div>
            <div className="ml-3">
              <p className="text-xs font-medium text-green-600">
                Resolved Alerts
              </p>
              <p className="text-xl font-bold text-green-900">
                {resolvedAlerts}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertSummary;
